import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { PinOnImageT } from '@mentimeter/question-modules-types';
import type { PinOnImageStaticContent } from '@core-api/presentation/types/response';
import { useFlag } from '@mentimeter/flags/confidence/client';
import { PinOnImagePresentation } from './PinOnImagePresentation';

// Needs to be a type instead of interface as the interface can't satisfy the generic used with useSlideState hook
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type SlideStatePinOnImage = { reveal?: boolean };

export const PinOnImagePresentationDataHandler = () => {
  const {
    useConfig,
    useQuestion,
    useResults,
    useSlideState,
    InteractiveCanvasComponents,
  } = usePresentationContext();

  const slide = useQuestion();
  const { enableAnimations, mode } = useConfig();
  const [slideState] = useSlideState<SlideStatePinOnImage>();
  const { reveal } = slideState || {};

  const { results = [] } = useResults<PinOnImageT>();

  const staticContent = slide.staticContent as PinOnImageStaticContent;

  let shouldShowCorrect: 'disabled' | 'enabled-visible' | 'enabled-hidden';
  if (slide.interactiveContents[0]!.correctAnswerMode === 'disabled') {
    shouldShowCorrect = 'disabled';
  } else if (reveal || ['screenshot', 'public'].includes(mode)) {
    shouldShowCorrect = 'enabled-visible';
  } else {
    shouldShowCorrect = 'enabled-hidden';
  }

  const imageUrl =
    slide.interactiveContents[0]!.image?.presets?.original.url ?? undefined;

  const { value: isNewLookFlagEnabled } = useFlag(
    'sli-new-look-pin-on-image.enabled',
    false,
  );

  return (
    <PinOnImagePresentation
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      longerDescription={slide.interactiveContents[0]!.description}
      fontSizeOffset={staticContent.textSizeOffset}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
      results={results}
      imageUrl={imageUrl}
      shouldShowCorrect={shouldShowCorrect}
      correctArea={slide.interactiveContents[0]!.correctArea}
      shouldAnimate={enableAnimations}
      isNewLookFlagEnabled={isNewLookFlagEnabled}
    />
  );
};
